import { useMutation } from '@tanstack/react-query';
import { getAuthService } from '../services/auth.service';
import { rememberAccessToken } from '../utils/agentsRequest';

export const useRefreshToken = () => {
    const mutation = useMutation({
        mutationFn: () => getAuthService().refreshToken(),
        mutationKey: ['refreshToken'],
        onSuccess: (response) => {
            if (response?.accessToken) {
                rememberAccessToken(response.accessToken);
            }
            if (response?.refreshToken) {
                localStorage.setItem('refreshToken', response.refreshToken);
            }
            return response;
        },
        onSettled: (_data, _error) => {
            // Reset mutation state after a short delay
            setTimeout(() => mutation.reset(), 100);
        },
        retry: 0,
    });

    return mutation;
};
